import api from './api';
import {
  PayrollRecord,
  PayrollSummary,
  RunPayrollData,
  PayslipTemplate,
  ApiResponse,
} from '../types';

export const payrollService = {
  async runPayroll(data: RunPayrollData): Promise<PayrollSummary> {
    const response = await api.post<ApiResponse<PayrollSummary>>('/payroll/run', data);
    return response.data.data!;
  },

  async getPayrollRecords(month: number, year: number): Promise<PayrollRecord[]> {
    const response = await api.get<ApiResponse<PayrollRecord[]>>(
      `/payroll?month=${month}&year=${year}`
    );
    return response.data.data!;
  },

  async getPayrollById(id: number): Promise<PayrollRecord> {
    const response = await api.get<ApiResponse<PayrollRecord>>(`/payroll/${id}`);
    return response.data.data!;
  },

  async getMyPayrollRecords(): Promise<PayrollRecord[]> {
    const response = await api.get<ApiResponse<PayrollRecord[]>>('/payroll/my-records');
    return response.data.data!;
  },

  async downloadPayslip(payrollId: number): Promise<Blob> {
    const response = await api.get(`/payroll/${payrollId}/payslip.pdf`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async exportToCsv(month: number, year: number): Promise<Blob> {
    const response = await api.get(`/payroll/export?month=${month}&year=${year}`, {
      responseType: 'blob',
    });
    return response.data;
  },

  async regeneratePayslip(payrollId: number): Promise<void> {
    await api.post(`/payroll/${payrollId}/regenerate-payslip`);
  },

  // Template management
  async uploadTemplate(file: File, name: string): Promise<PayslipTemplate> {
    const formData = new FormData();
    formData.append('template', file);
    formData.append('name', name);
    
    const response = await api.post<ApiResponse<PayslipTemplate>>(
      '/payroll/template/upload',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data.data!;
  },

  async getActiveTemplate(): Promise<PayslipTemplate | null> {
    const response = await api.get<ApiResponse<PayslipTemplate>>('/payroll/template');
    return response.data.data || null;
  },

  async getAllTemplates(): Promise<PayslipTemplate[]> {
    const response = await api.get<ApiResponse<PayslipTemplate[]>>('/payroll/templates');
    return response.data.data!;
  },

  async setActiveTemplate(id: number): Promise<PayslipTemplate> {
    const response = await api.put<ApiResponse<PayslipTemplate>>(
      `/payroll/template/${id}/activate`
    );
    return response.data.data!;
  },

  async deleteTemplate(id: number): Promise<void> {
    await api.delete(`/payroll/template/${id}`);
  },
};
